import { isObject } from '../ValidationHelper/isObject';
export var getClassName = function (element) {
    var clsName = '';
    if (isObject(element, HTMLElement)) {
        var className = element.className;
        clsName = className;
    }
    else if (isObject(element, SVGElement)) {
        // tslint:disable-next-line: deprecation
        clsName = element.className.baseVal;
    }
    return clsName;
};
//# sourceMappingURL=getClassName.js.map